import React from "react";
import {Polygon as PolygonGoogleMap} from "react-google-maps";


const Polygon = ({data}) => {
    const paths = data.geometry.coordinates[0].map(coord => {
        return {lat: coord[1], lng: coord[0]}
    });
    return (
        <PolygonGoogleMap
            paths={paths}
        />
    );
};

export default Polygon;

